import { Redirect, Route, Router, Switch } from "react-router-dom";
import { LoginCallback, SecureRoute, Security } from "@okta/okta-react";
import { AuthState, OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { createBrowserHistory } from 'history';
import Login from "./pages/Login";
import Home from "./pages/Home";
import Logout from "./pages/Logout";
import Signout from "./pages/Signout";
import './App.css';

function App() {

  const appHistory = createBrowserHistory();
  const oktaAuth = new OktaAuth({
    issuer: process.env.REACT_APP_OKTA_BASE_URL,
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
    redirectUri: `${window.location.origin}/callback`,
    scopes: ["openid", "email", "profile"]
  });

  oktaAuth.authStateManager.subscribe((authState: AuthState) => {
    const appConfig = authState.accessToken?.accessToken ? { REACT_APP_WEBAPP_URL: process.env.REACT_APP_WEBAPP_URL, REACT_APP_EUM_URL: process.env.REACT_APP_EUM_URL, REACT_APP_SEARCH_URL: process.env.REACT_APP_SEARCH_URL } : {};
    window.postMessage({ type: "FROM_PV_WEB_APP_TO_EXTENSION", accessToken: `${authState.accessToken?.accessToken || undefined}`, appConfig }, window.location.origin);
  });

  function onAuthRequired() {
    appHistory.push('/login');
  }

  const restoreOriginalUri = async (_oktaAuth: OktaAuth, originalUri: string) => {
    appHistory.replace(toRelativeUrl(originalUri || '/', window.location.origin));
  };

  return (
    <div className="App">
      <Router history={appHistory}>
        <Security
          oktaAuth={oktaAuth}
          onAuthRequired={onAuthRequired}
          restoreOriginalUri={restoreOriginalUri}
        >
          <Switch>
            <Route path="/login" exact={true} component={Login} />
            <Route path="/callback" exact={true} component={LoginCallback} />

            <Switch>
              <Redirect from="/" to={"/home"} exact={true} />
              <Redirect from="/callback" to={"/home"} />
              <SecureRoute path="/home" component={Home} />
              <Route path={"/signout"} component={Signout} />
              <Route path={"/logout"} component={Logout} />
            </Switch>
          </Switch>
        </Security>
      </Router>
    </div>
  );
}

export default App;
